export const PLAYERS = [
  'giorgi-mamardashvili-2024-limited-666',
  'david-raya-martin-2024-limited-647',
  'gregor-kobel-2024-limited-650',
  'gianluigi-donnarumma-2024-limited-663',
  'mike-maignan-2024-limited-173',
  'thibaut-courtois-2024-limited-556',

  'trent-alexander-arnold-2024-limited-624',
  'jules-kounde-2024-limited-637',
  'leny-yoro-2024-limited-565',
  'achraf-hakimi-mouh-2024-limited-640',
  'levi-colwill-2024-limited-671',
  'dayotchanculle-upamecano-2024-limited-619',

  'florian-wirtz-2024-limited-640',
  'xavi-simons-2024-limited-612',
  'alexis-mac-allister-2024-limited-661',
  'bruno-guimaraes-rodriguez-moura-2024-limited-657',
  'martin-zubimendi-ibanez-2024-limited-566',
  'pedro-gonzalez-lopez-2024-limited-656',

  'kylian-mbappe-lottin-2024-limited-608',
  'lamine-yamal-nasraoui-ebana-2024-limited-630',
  'alexander-isak-2024-limited-673',
  'mohamed-salah-ghaly-2024-limited-638',
  'michael-olise-2024-limited-655',
  'lois-openda-2024-limited-620',
];
